module.exports = __webpack_public_path__ + "img/oursPlatform.be390a5c.png";